import dataCollectionPage from './view/dataCollection.html';
import utils from 'utils';
import { angular } from 'eslint-plugin-angular/environments';

export default function dataCollection(
  $uibModal,
  httpRequest,
  logger,
  modalSelConDetailService,
  operationService,
  $timeout,
  Upload,
  $filter
) {
  return {
    restrict: 'E',
    scope: {
      active: '@',
      searchtime: '=',
      action: '&',
    },
    template: dataCollectionPage,
    link(scope) {
      if (
        !operationService.hasPermit('sales_collection') &&
        !operationService.hasPermit('input_collection')
      ) {
        return;
      }
      scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
      scope.select = {}
      scope.treeConfig = {
          isCheckall: true,
          check: {
              //如果没有设置配置项，取默认配置
              enable: true, //显示不显示复选框
              chkboxType: { Y: '', N: '' },
          },
      }
      scope.importBtnCollapsed = false;
      scope.activeTab = `${scope.active}`;
      // 导入、模板下载接口参数
      let importTypeCode = '';
      let typeCode = '';
      scope.selectedRows = [];
      // 发票类型过滤 字典
      const typecodeArr = [
        'glsale_businessType', //销项发票申报收集-业务类型
        'glsale_taxMethod', //销项发票申报收集-计税方式
        'glsale_signAndRetreat', //'销项发票申报收集-是否即征即退
        'glsale_rateDetails', //销项发票申报收集-征税项目税率明细
        'glsale_invoiceType', //销项发票申报收集-发票类型
        'glsale_status', //销项发票申报收集-有效状态'
        'glincome_voucherType', //'进项发票申报收集-进项凭证类别
        'glincome_invoiceType', //'进项发票申报收集-发票类型
        'glincome_retreatOption', //进项发票申报收集-即征即退选项
        'glincome_deduction', //进项发票申报收集-抵扣情况
        'department_no', //事业部
        'glincome_dataSources', // 数据来源
        'glsale_taxItem', //征税项目
        'zzs_status', //是否开启申报
      ];
      scope.dictionary = {
        // 是否全部征税项目
        YES_NO: [
          {
            enumName: '否',
            enumCode: '0',
          },
          {
            enumName: '是',
            enumCode: '1',
          },
        ],
      };
      httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
        scope.dictData = scope.dictionary = $.extend(
          scope.dictionary,
          res.data.value
        );
        scope.queryGlsale_rateDetails =  Object.assign(scope.dictData['glsale_rateDetails']).filter(item => item.enumCode != 14 &&item.enumCode != 15 && item.enumCode != 16 && item.enumCode != 17);
      });
      // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
      httpRequest.get_getBelleRegion().then((res) => {
        scope.belleRegionList = res.data.value;
      });
      // 获取所有主管税局信息
      httpRequest
        .get_getAllTaxBureau(localStorage.getItem('id_token'))
        .then((res) => {
          scope.dictDataProvince = res.data.value;
        });
      scope.orderMap = {
        sortKey: '',
        sortVal: '',
      };
      // 重置
      scope.reset = function (resetNum) {
        scope.param =
          scope.activeTab == 1
            ? {
                pageNum: 1,
                pageSize: 10,
                param: {
                  applyPeriod: scope.searchtime, //税款所属期
                  businessType: resetNum, //业务类型
                  state: '1',
                },
              }
            : {
                pageNum: 1,
                pageSize: 10,
                param: {
                  applyPeriod: scope.searchtime, //税款所属期
                  companyName: '', //纳税人名称
                  voucherType: scope.voucherType,
                  state: '1',
                },
              };
      };
      // 排序操作
      scope.orderMap = {
        sortKey: '',
        sortVal: '',
      };
      scope.selectedHandle = function selectedHandle() {
        scope.param.orderMap = {};
        if (scope.orderMap.sortKey)
          scope.param.orderMap[scope.orderMap.sortKey] = scope.orderMap.sortVal;
        scope.qrySelecInfo();
      };

      // 分页
      scope.totalItems = 0; // 组件初始化设置总页数
      //查询
      scope.qrySelecInfo = function (time) {
        const openLoading =
          scope.param.pageSize >= 100
            ? window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
              })
            : null;
        // 时间变化更新
        scope.param.param.applyPeriod = scope.searchtime;
        if (scope.activeTab == 1) {
          httpRequest
            .post_getSbSalesList(queryDataHandle(scope.param))
            .then((res) => {
              if (res.data.success) {
                //税号 计税方式 征税项目 税率明细相同 数据合并处理
                if (scope.invType === 'normal') {
                  scope.mergingList = scope.taxDataMerging(res.data.value.list);
                  scope.sbSalesInfoList = scope.mergingList;
                  // //合并之后的总条数
                  // scope.totalItems = scope.sbSalesInfoList.length
                } else {
                  scope.sbSalesInfoList = res.data.value.list;
                  scope.totalItems = res.data.value.total;
                }
                scope.selectedRows = [];
                // 获取后台分页数据 回写分页组件
                scope.totalItems = res.data.value.total;
                scope.param.pageNum = ++res.data.value.prePage;
                scope.param.pageSize = res.data.value.pageSize;
              }
            })
            .finally(() => {
              window.layer.close(openLoading);
            });
        }
        if (scope.activeTab == 2) {
          httpRequest
            .post_getSbIncomeList(queryDataHandle(scope.param))
            .then((res) => {
              if (res.data.success) {
                scope.getSbIncomeList = res.data.value.list;
                scope.selectedRows = [];
                // 获取后台分页数据 回写分页组件
                scope.totalItems = res.data.value.total;
                scope.param.pageNum = ++res.data.value.prePage;
                scope.param.pageSize = res.data.value.pageSize;
              }
            })
            .finally(() => {
              window.layer.close(openLoading);
            });
        }
      };
      function queryDataHandle(queryData) {
       scope.employeeList = []
        const { selectedFollower } =scope.select
        selectedFollower.forEach(item => {
            scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = scope.employeeList
        return queryData
    }
      // 数据合并处理 函数封装
      scope.taxDataMerging = function (arr) {
        let newArr = [];
        arr.forEach((item) => {
          let dataItem = item;
          if (newArr.length > 0) {
            let filterValue = newArr.filter((v) => {
              return (
                v.taxNo == dataItem.taxNo &&
                v.taxCalculationMethod == dataItem.taxCalculationMethod &&
                v.taxItem == dataItem.taxItem &&
                v.taxRateDetails == dataItem.taxRateDetails
              );
            });
            if (filterValue.length > 0) {
              // 相同处理
              newArr.forEach((n) => {
                if (
                  n.taxNo == filterValue[0].taxNo &&
                  n.taxCalculationMethod ==
                    filterValue[0].taxCalculationMethod &&
                  n.taxItem == filterValue[0].taxItem &&
                  n.taxRateDetails == filterValue[0].taxRateDetails
                ) {
                  n.taxAmount = n.taxAmount + dataItem.taxAmount;
                  n.amount = n.amount + dataItem.amount;
                  n.otherAmount = n.otherAmount + dataItem.otherAmount;
                  n.otherTaxAmount = n.otherTaxAmount + dataItem.otherTaxAmount;
                }
              });
            } else {
              let newDataItem = {};
              newDataItem = $.extend(newDataItem, dataItem);
              newArr.push(newDataItem);
            }
          } else {
            let newDataItem = {};
            newDataItem = $.extend(newDataItem, dataItem);
            newArr.push(newDataItem);
          }
        });
        return newArr;
      };
      // 点击页码
      scope.pageChanged = () => {
        scope.qrySelecInfo();
      };
      // 导入
      scope.uploadFiles = function uploadFiles(file, errFiles) {
        if (file == null && errFiles.length >= 1) {
          logger.logError(
            '文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入'
          );
          return;
        }
        if (file) {
          file.upload = Upload.upload({
            url: `${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/importSales`,
            data: {
              importFile: file,
              code: importTypeCode,
              applyPeriod: scope.searchtime,
            },
          });
          // 文件上传
          // loading动画
          const importinglayer = layer.msg('玩命上传中，请耐心等待', {
            time: 0,
            skin: 'layer-loading-self',
            icon: 16,
            shade: 0.5,
          });
          file.upload.then(
            (res) => {
              console.log(res);
              $timeout(() => {
                if (!res.data.success) {
                  layer.close(importinglayer);
                  return logger.logError(res.data.message || '上传失败');
                }
                if (res.data.value.sourceCount === 0) {
                  layer.close(importinglayer);
                  return logger.logTips('导入数据为空！', 'warn');
                }
                const { batchNo, sourceCount, errorCount } = res.data.value;
                // 结果弹框
                // if (res.data.value.errorCount > 0) {
                httpRequest
                  .post_getPageDlBatchInfoList({
                    pageNum: 1,
                    pageSize: 10,
                    param: res.data.value.batchNo,
                  })
                  .then((res1) => {
                    console.log(res1);
                    layer.close(importinglayer);
                    importErrorModal({
                      batchNo,
                      sourceCount,
                      successCount: sourceCount - errorCount,
                      errorCount,
                      data: res1.data.value,
                      data: res1.data.value,
                      activeTab: scope.activeTab,
                      invType: scope.invType,
                    });
                    scope.qrySelecInfo();
                  });
              });
            },
            (response) => {
              // if (response.status > 0) {
              //   layer.close(importinglayer)
              //   logger.logError('上传失败')
              // }
            }
          );
        }
      };
      // 结果弹框
      const importErrorModal = function importErrorModal(modalData) {
        const modalInstance = $uibModal.open({
          templateUrl: 'importError.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            'logger',
            'items1',
            function ($scope, $uibModalInstance, logger, items1) {
              $scope.modalData = items1;
              $scope.invType = items1.invType;
              $scope.list = items1.data.list;
              $scope.list.forEach((item) => {
                $scope.invType === 'normal'
                  ? handleListData(item)
                  : CP_handleListData(item);
              });
              $scope.pageOptions = {
                // 分页器
                totalItems: $scope.modalData.data.total,
                currentPage: ++$scope.modalData.data.prePage,
                maxSize: $scope.modalData.data.pageSize,
              };
              function handleListData(data) {
                let obj = JSON.parse(data.rowContent);
                data.invoiceCode = obj.invoiceCode;
                data.invoiceNumber = obj.invoiceNumber;
              }
              function CP_handleListData(data) {
                let obj = JSON.parse(data.rowContent);
                data.billId = obj.billId;
              }
              function queryList() {
                httpRequest
                  .post_getPageDlBatchInfoList({
                    pageNum: $scope.pageOptions.currentPage,
                    pageSize: $scope.pageOptions.maxSize,
                    param: $scope.modalData.batchNo,
                  })
                  .then((res) => {
                    $scope.list = res.data.value.list;
                    $scope.list.forEach((item) => {
                      $scope.invType === 'normal'
                        ? handleListData(item)
                        : CP_handleListData(item);
                    });
                    $scope.pageOptions = {
                      // 分页器
                      totalItems: res.data.value.total,
                      currentPage: ++res.data.value.prePage,
                      maxSize: res.data.value.pageSize,
                    };
                  });
              }

              $scope.pageChanged = () => {
                queryList();
              };
              $scope.ok = () => {
                $uibModalInstance.close();
              };
            },
          ],
          backdrop: 'static',
          openedClass: 'mod-modal-importexcel',
          windowClass: 'mod-modal mod-modal-lg',
          bindToController: true,
          resolve: {
            items1() {
              return modalData;
            },
          },
        });
        modalInstance.result.then(
          () => {},
          () => {}
        );
      };
      // 模板下载
      scope.downloadExcel = function downloadExcel() {
        window.open(
          `${
            host.etcloudIvatApp
          }taxdeclaration/rpaGsConfig/exportRpaGsConfigTemple?code=${typeCode}&accessToken=${localStorage.getItem(
            'id_token'
          )}`
        );
      };
      //导出
      scope.exportExel = function exportExel() {
        let url = `${
          host.etcloudIvatApp
        }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem(
          'id_token'
        )}`;
        let exportType = '',
          fileName = '',
          param = {},
          type = '';
        if (scope.activeTab == 1) {
          type = 'sb_summary';
          exportType = 'businessType';
          fileName = '已开具发票采集导出模板（一般）';
          param = {
            applyPeriod: scope.param.param.applyPeriod,
            businessType: scope.voucherType,
          };
        } else {
          type = 'sb_transportation';
          param = {
            applyPeriod: scope.param.param.applyPeriod,
            voucherType: scope.voucherType,
          };
          fileName = '认证相符的增值税专用发票导出模板（一般）';
        }
        utils.file_download(url, param, type, 'POST', 'blob', fileName, false);
      };

      // 批量删除
      scope.batchDeletion = function () {
        if (!scope.selectedRows.length) {
          return logger.logError('请选择数据后操作');
        }
        let params = {
          applyPeriod: scope.searchtime,
          ids: scope.selectedRows,
        };
        httpRequest
          .post_batchSalesOrIncomeDelete(
            JSON.stringify(params),
            false,
            scope.activeTab
          )
          .then((res) => {
            if (res.data.msgCode == 90015) {
              // deletionErrorModal(res.data.message)
              logger.logError(res.data.message);
              return;
            }
            logger.logSuccess(res.data.value);
            scope.qrySelecInfo();
          });
      };
      // 批量删除错误弹框
      const deletionErrorModal = function (modalData) {
        const modalInstance = $uibModal.open({
          templateUrl: 'deletionErrorModal.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            'logger',
            'items1',
            function ($scope, $uibModalInstance, logger, items1) {
              $scope.errorData = modalData;
              $scope.ok = () => {
                $uibModalInstance.close();
              };
              $scope.cancel = () => {
                $uibModalInstance.dismiss();
              };
            },
          ],
          backdrop: 'static',
          openedClass: 'mod-modal mod-modal-md',
          bindToController: true,
          resolve: {
            items1() {
              // return modalData
            },
          },
        });
        modalInstance.result.then();
      };

      // 发票种类切换
      scope.invTypeChange = function (v, num) {
        //业务类型
        scope.voucherType = num;
        scope.invType = v;
        scope.orderMap = {
          sortKey: '',
          sortVal: '',
        };
        scope.param =
          scope.activeTab == 1
            ? {
                pageNum: 1,
                pageSize: 10,
                param: {
                  applyPeriod: scope.searchtime, //税款所属期
                  businessType: num, //业务类型
                  state: '1',
                },
              }
            : {
                pageNum: 1,
                pageSize: 10,
                param: {
                  applyPeriod: scope.searchtime, //税款所属期
                  voucherType: num,
                  state: '1',
                },
              };
        //用户自定义缓存
        scope.invType === 'normal' &&
          (scope.profileType = scope.activeTab == '1' ? '152' : '154');
        scope.invType === 'deny' &&
          (scope.profileType = scope.activeTab == '1' ? '153' : '155');
        // 销项搜索字段,字段设置
        let invListLabelConfigOutput =
          scope.invType === 'normal'
            ? {
                version: 1.6,
                invListLabel: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '计税方式',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '所属区域',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '主管税局省（市）',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '是否全部征税项目',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '征税项目税率明细',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '是否开启申报',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '跟进人',
                    selected: false,
                    default: false,
                  },
                ],
                table: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '主管税局省（市）',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '计税方式',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '征税项目',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '征税项目税率明细',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '开具增值税专用发票销售额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '开具增值税专用发票销项（应纳）税额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '开具其他发票销售额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '开具其他发票销项（应纳）税额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '所属区域',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '是否开启申报',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '跟进人',
                    selected: true,
                    default: true,
                  },
                ],
              }
            : {
                version: 1.6,
                invListLabel: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '计税方式',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '所属区域',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '主管税局省（市）',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '是否即征即退',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '征税项目',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '是否开启申报',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '跟进人',
                    selected: true,
                    default: true,
                  },
                ],
                table: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '所属区域',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '主管税局省（市）',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '计税方式',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '是否即征即退',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '征税项目税率明细',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '销售额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '税率',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '税额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '征税项目',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '是否开启申报',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '跟进人',
                    selected: true,
                    default: true,
                  },
                ],
              };
        // 进项搜索字段,字段设置
        let invListLabelConfigIncome =
          scope.invType === 'normal'
            ? {
                version: 1.6,
                invListLabel: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '进项凭证类别',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '所属区域',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '主管税局省（市）',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '是否开启申报',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '跟进人',
                    selected: true,
                    default: true,
                  },
                ],
                table: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '主管税局省（市）',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '进项凭证类别',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '发票份数',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '金额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '税额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '所属区域',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '是否开启申报',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '跟进人',
                    selected: true,
                    default: true,
                  },
                ],
              }
            : {
                version: 1.6,
                invListLabel: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '所属区域',
                    selected: false,
                    default: false,
                  },
                  {
                    label: '主管税局省（市）',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '发票类型',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '即征即退选项',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '抵扣情况',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '是否开启申报',
                    default: false,
                    selected: false,
                  },
                  {
                    label: '跟进人',
                    selected: true,
                    default: true,
                  },
                ],
                table: [
                  {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '事业部',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '所属区域',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '主管税局省（市）',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '数据来源',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '发票类型',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '发票份数',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '金额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '税额',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '即征即退项目',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '抵扣情况',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '是否开启申报',
                    selected: true,
                    default: true,
                  },
                  {
                    label: '跟进人',
                    selected: true,
                    default: true,
                  },
                ],
              };
        scope.invListLabelConfig =
          scope.activeTab == 1
            ? invListLabelConfigOutput
            : invListLabelConfigIncome;

        // scope.qrySelecInfo();
        getUserInfo()

        // 导入下载的code
        if (scope.invType === 'deny') {
          typeCode =
            scope.activeTab == '1'
              ? 'SB_SALES_NOTIMPORT' //增值税销项未开具发票
              : 'SB_INCOME_NOTIMPORT'; //增值税进项旅客运输发票
          importTypeCode =
            scope.activeTab == '1'
              ? 'SB_SALES_IMPORT' //增值税销项未开具发票
              : 'SB_INCOME_IMPORT'; //增值税进项旅客运输发票
        }
      };
      function getUserInfo() {
        scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            scope.followerList = dataHandle(res.data.value)
            scope.select.selectedFollower = scope.followerList.filter((x) => { return x.employeeName == scope.currentUserInfo.realName})
            scope.qrySelecInfo();
        })
      }
      function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if (scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
      scope.invTypeChange('normal', '1');
    }, //link end
    controller: [
      '$scope',
      '$rootScope',
      ($scope, $rootScope) => {
        // 父组件传过来事件
        $rootScope.$on('dataCollectionSearch', function (time) {
          $scope.qrySelecInfo();
        });
      },
    ],
  };
}

dataCollection.$inject = [
  '$uibModal',
  'httpRequest',
  'logger',
  'modalSelConDetailService',
  'operationService',
  '$timeout',
  'Upload',
  '$filter',
];



// WEBPACK FOOTER //
// ./src/components/dataCollection/dataCollection.js